import {
    IconBuilding,
    IconBuildingSkyscraper,
    IconUsers,
    IconHeartHandshake,
    IconBuildingBank,
    IconPlant2,
    IconBuildingFactory2,
    IconUser,
    IconWorld,
    IconBriefcase,
} from '@tabler/icons-react';

export const DEFAULT_BUSINESS_FORM_ICON = IconBuilding;

export function iconForBusinessForm(lloji) {
    if (!lloji || !String(lloji).trim()) return DEFAULT_BUSINESS_FORM_ICON;
    const v = String(lloji).trim().toLowerCase();
    if (v.includes('individual')) return IconUser;
    if (v.includes('kufizuara') || v.includes('limited liability') || v.includes('ograničenom')) return IconBuildingSkyscraper;
    if (v.includes('ortakëri e kufizuar') || v.includes('limited partnership') || v.includes('ograničen')) return IconHeartHandshake;
    if (v.includes('ortakëri') || v.includes('partnership') || v.includes('ortakluk')) return IconUsers;
    if (v.includes('aksionare') || v.includes('joint stock') || v.includes('akcionarsko')) return IconBuildingBank;
    if (v.includes('bujqësore') || v.includes('agricultur') || v.includes('zemljoradnič')) return IconPlant2;
    if (v.includes('huaj') || v.includes('foreign') || v.includes('strane')) return IconWorld;
    if (v.includes('përfaqësisë') || v.includes('representative') || v.includes('predstavni')) return IconBriefcase;
    if (v.includes('shoqërore') || v.includes('publike') || v.includes('ndërmarrje') || v.includes('socially') || v.includes('public') || v.includes('društveno') || v.includes('javno')) return IconBuildingFactory2;
    return DEFAULT_BUSINESS_FORM_ICON;
}
